import { EvEbitValues, EvEbitResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateEvEbit(values: EvEbitValues, t?: ToolsTranslations['evEbit']): EvEbitResult {
  const { enterpriseValue, ebit } = values;

  if (enterpriseValue <= 0) {
    return { evEbit: null, isValid: false, message: t?.invalid.enterpriseValue ?? 'Enterprise value måste vara större än 0' };
  }
  if (ebit <= 0) {
    return { evEbit: null, isValid: false, message: t?.invalid.ebit ?? 'EBIT måste vara större än 0' };
  }

  const evEbit = Math.round((enterpriseValue / ebit) * 100) / 100; // PREC(...,2) - rounds to 2 decimal places
  
  if (!isFinite(evEbit)) {
    return { evEbit: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }
  
  return { evEbit, isValid: true };
}
